import { StandardEvents } from '@shopify/events';
class LukeSetHelper extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(StandardEvents.productSelect, async event => {
      const generation = this.generation = (this.generation || 0) + 1;
      try {
        const { detail } = await event.promise;
        if (!this.isConnected || generation !== this.generation || !detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
        const next = detail.html.querySelector(`luke-set-helper[data-product-id="${this.dataset.productId}"][data-helper-kind="${this.dataset.helperKind || 'set'}"]`);
        this.hidden = !next || next.hidden;
        if (next) this.innerHTML = next.innerHTML;
      } catch { /* Keep the last confirmed selection while the native picker handles failures. */ }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('luke-set-helper')) customElements.define('luke-set-helper', LukeSetHelper);
